import type { InjectedRouter } from 'js/lib/connectToRouter';

import type { Specialization } from 'bundles/enterprise-admin-program-catalog/types';
import type { CurriculumItem, ProgramCurriculums } from 'bundles/naptimejs/resources/programCurriculums.v1';

export const addContentUsingNewProgramCreation = ({
  programCurriculum,
  trackId,
  router,
}: {
  programCurriculum: ProgramCurriculums;
  trackId: string;
  router: InjectedRouter;
}) => {
  const { thirdPartySlug, programSlug } = router.params;
  const matchId = ({ id }: { id: string }) => id === trackId;
  const { coreTracks = [], electiveTracks = [] } = programCurriculum.definition;
  const collection = coreTracks.find(matchId) ?? electiveTracks.find(matchId);

  if (!collection) {
    throw Error(`Collection not found: ${trackId}`);
  }

  const path = `/o/${thirdPartySlug}/program-creation/${programSlug}/collection-content-search?collectionId=${encodeURIComponent(
    collection.id
  )}&continueTo=catalog`;

  router.push(path);
};

export const stringifyProductId = (_: CurriculumItem) => {
  if (_.typeName === 'clipId') return `${_.definition.courseId}~${_.definition.itemId}`;
  return `${_.definition.id}`;
};

export const getSpecializationId = (product: Specialization): string => {
  if (product.id.startsWith('child~') && product.baseSpecialization) {
    return product.baseSpecialization.id;
  }
  return product.id;
};
